import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GeminiImageService {
  private readonly endpoint =
    'https://pffvieeq54yajkvxq6g4xcubya0fsdot.lambda-url.us-east-1.on.aws/';

  constructor(private http: HttpClient) {}

  async editImage(base64Image: string, mimeType: string, prompt: string): Promise<string> {
    const body = {
      prompt,
      image: {
        data: base64Image,
        mimeType
      }
    };

    const response = await firstValueFrom(this.http.post<any>(this.endpoint, body));

    if (response?.error) {
      throw new Error(response.error);
    }

    if (!response?.imageBase64) {
      throw new Error('The AI provided a response but no image was found.');
    }

    return response.imageBase64;
  }
}
